import { useIsMutating } from "@tanstack/react-query";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";

export const useIsDocumentTransferPending = () =>
	useIsMutating({ mutationKey: DocumentKeys.transfer }) > 0;
